import authService from 'leo-services/authService';
import { viewRight } from 'leo-configs/constant';
import allMenuList from './menu';

export default {
  name: 'main',
  state: {
    loading: true,
    hasLogin: false,
    couldLocationReivew: false,
    userName: '',
    showMenu: false,
    menuList: [],
    authorities: [],
  },
  effects: dispatch => ({
    async getUserInfo() {
      try {
        const result = await authService.getUserInfo();
        if (result) {
          this.setUserData(result);
        }
      } catch (e) {
        this.handleNoToken();
      }
    },
    async login({ account, password }) {
      const result = await authService.login(account, password);
      if (result) {
        this.applyLoginResponse(result);
      }
    },
    async dingTalkInternalLogin(authCode) {
      const result = await authService.dingTalkInternalLogin(authCode);
      if (result) {
        this.applyLoginResponse(result);
      }
      return result;
    },
    applyLoginResponse(result) {
      this.setUserData({
        authorities: result.authorities,
        ...result.user,
        companyId: result.user.company && result.user.company.id,
      });
    },
  }),
  reducers: {
    couldLocationReivew(state) {
      state.couldLocationReivew = true;
      return state;
    },
    handleNoToken(state) {
      state.loading = false;
    },
    setUserData(state, { companyId, authorities, id, name }) {
      if (companyId === 6) {
        authorities.push('COMPANY_SUMMARY');
      }
      authorities.push('ALL');

      state.loading = false;
      state.authorities = authorities;
      state.userName = name;
      state.hasLogin = !!id;
      const filterMenu = (list) => {
        for (let i = 0; i < list.length;) {
          const item = list[i];
          if (
            viewRight[item.rightKey] &&
            // authorities里有当前view所需要的权限
            viewRight[item.rightKey].some(rightName => authorities.includes(rightName))
          ) {
            i++;
          } else {
            list.splice(i, 1);
          }

          if (item.children) {
            filterMenu(item.children);
          }
        }

        // return list.filter(item => (
        //   viewRight[item.rightKey] &&
        //   // authorities里有当前view所需要的权限
        //   viewRight[item.rightKey].some(rightName => authorities.includes(rightName))
        // ));
        // .filter(item => item.children && item.children.some(rightName => authorities.includes(rightName)));
      };
      // 有权限的menu
      filterMenu(allMenuList);
      state.menuList = allMenuList;

      // state.menuList = allMenuList.filter(item => (
      //   viewRight[item.rightKey] &&
      //   // authorities里有当前view所需要的权限
      //   viewRight[item.rightKey].some(rightName => authorities.includes(rightName))
      // ));

      return state;
    },
    switchMenu(state, type) {
      state.showMenu = type;
      return state;
    },
  },
};
